module.exports = __webpack_public_path__ + "img/icon-remove-img.f21e8787.svg";